import React from 'react';
import { BookOpenIcon, GiftIcon, StethoscopeIcon, TableIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  text: '6 comprehensive volumes'
}, {
  icon: GiftIcon,
  text: '5 specialized bonuses'
}, {
  icon: TableIcon,
  text: 'Tables, worksheets & case studies'
}];
export function Hero() {
  return <header className="bg-navy-950 text-white" data-id="element-198" data-mp="mutu7lwc07a4">
      <div className="bg-cta px-4 py-2.5 text-center text-sm font-bold text-navy-950" data-id="element-199" data-mp="mrxwnyoebkm7">
        Introductory offer · Complete collection for just $27 USD
      </div>

      <div className="mx-auto max-w-6xl px-4 pb-14 pt-8 sm:pt-14 lg:grid lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-14 lg:pb-20" data-id="element-200" data-mp="vnnexyujryvd">
        <div data-id="element-201" data-mp="10n9re62jxb34">
          <p className="flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-aqua" data-id="element-202" data-mp="15ks4m8nlqcgx">
            <StethoscopeIcon className="h-5 w-5" aria-hidden="true" data-id="element-203" data-mp="1aitp8y0oejui" />
            ABG Clinical Roadmap™
          </p>
          <h1 className="mt-4 font-display text-[2.6rem] font-black leading-[1.02] tracking-tight sm:text-6xl lg:text-[4.2rem]" data-id="element-204" data-mp="9olwk650zsls">
            Master ABG Interpretation in <span className="text-cta" data-id="element-205" data-mp="3vur74pfi5cwm">15 Minutes a Day</span>
          </h1>
          <p className="mt-4 text-xl font-semibold leading-snug text-aqua sm:text-2xl" data-id="element-206" data-mp="3vwu987txiwhp">
            With a structured 6-volume educational system
          </p>

          <div className="mt-7 rounded-3xl bg-white p-2 shadow-[0_30px_60px_-20px_rgba(46,211,230,0.35)] lg:hidden" data-id="element-207" data-mp="sczb8zy8w8t5">
            <img src={images.mockup} alt="ABG Clinical Roadmap collection: six volumes, quick-reference cards, worksheets and case studies" className="w-full rounded-2xl" data-id="element-208" data-mp="nfzfbhv40mfr" />
          </div>

          <p className="mt-7 text-lg leading-relaxed text-white/80" data-id="element-209" data-mp="1b4js54p0msqq">
            A step-by-step educational roadmap designed to help you organize arterial blood gas concepts, study acid-base
            disorders, understand compensation principles, and practice interpretation through structured learning exercises.
          </p>

          <ul className="mt-6 grid gap-2.5 sm:grid-cols-3" data-id="element-210" data-mp="35jyzt3rtwqce">
            {highlights.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-2.5 text-[15px] font-semibold text-white" data-id="element-211" data-mp="2qvku8l312ns5">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-aqua/15 text-aqua" data-id="element-212" data-mp="2vte3xo3jhzx6">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-213" data-mp="2hxsejfte9e48" />
                </span>
                {text}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-214" data-mp="27yjouz5kalno">
            <CtaButton id="first-cta" label="Yes! I want the ABG Clinical Roadmap™" data-id="element-215" data-mp="27zcl366w9srk" />
            <p className="mt-4 text-center text-sm font-medium text-white/70 lg:text-left" data-id="element-216" data-mp="2cwl75hv5ygy3">
              Instant digital access · One-time payment of $27 USD · No monthly subscription
            </p>
          </div>

          <div className="mt-8 flex items-center gap-3 border-t border-white/10 pt-6" data-id="element-217" data-mp="b2lzd6h92hq5">
            <img src={images.rachel} alt="Rachel Bennett" className="h-12 w-12 rounded-full object-cover object-top ring-2 ring-aqua" data-id="element-218" data-mp="1vkxv8tnr97lt" />
            <div data-id="element-219" data-mp="25e4wc2bgq1g3">
              <p className="font-bold" data-id="element-220" data-mp="25en33svr3y29">Rachel Bennett</p>
              <p className="text-sm text-white/65" data-id="element-221" data-mp="20lbrlefzut40">Critical Care Nursing Educator</p>
            </div>
          </div>

          <p className="mt-6 text-xs leading-relaxed text-white/45" data-id="element-222" data-mp="2ebozjgsvy7tc">
            The 15-minute reference refers to a focused study session, not mastery of ABG interpretation or completion of a
            clinical assessment.
          </p>
        </div>

        <div className="hidden lg:block" data-id="element-223" data-mp="2jc3bh9xly1wn">
          <div className="rounded-[2rem] bg-white p-3 shadow-[0_40px_80px_-24px_rgba(46,211,230,0.4)]" data-id="element-224" data-mp="2jd4ovl23j0hj">
            <img src={images.mockup} alt="ABG Clinical Roadmap collection: six volumes, quick-reference cards, worksheets and case studies" className="w-full rounded-3xl" data-id="element-225" data-mp="txx1kn29vuez" />
          </div>
        </div>
      </div>
    </header>;
}